// import cbreLogo from "@assets/images/cbreLogo.svg";

const Footer = () => {
 
  return (
    <>
    <div className="text-[0.45rem] text-default">
        © 2025 CBRE, Inc. We obtained the information above from sources we believe to be reliable. However, we have not verified its accuracy and make no guarantee, warranty or representation about it. It is submitted subject to the possibility of errors, omissions, change of price, rental or other conditions, prior sale, lease or financing, or withdrawal without notice. We include projections, opinions, assumptions or estimates for example only, and they may not represent current or future performance of the property. You and your tax and legal advisors should conduct your own investigation of the property and transaction.
    </div>
    <div>
        <svg 
        xmlns="http://www.w3.org/2000/svg" 
        id="Layer_1" 
        data-name="Layer 1" 
        viewBox="0 0 81 20.13" 
        className="h-3 text-primary"
        >
        <path 
            className="cls-1" 
            d="M33.57,15.41H26.89V12.05h6.86a1.66,1.66,0,0,1,1.49,1.64,1.73,1.73,0,0,1-1.67,1.72m-6.68-11h7A1.64,1.64,0,0,1,35.3,6a1.72,1.72,0,0,1-1.43,1.68h-7Zm9.94,5.37c2.56-.85,3-3,3-4.75,0-2.68-1.89-5-7.48-5H21.94V20.09h10.4C38,20.09,40,17.21,40,14.32a4.91,4.91,0,0,0-3.19-4.58M63.37,0V20.13H81V15.54H68.28V12H79.75V7.63H68.28V4.39H81V0ZM55.79,6.26a1.65,1.65,0,0,1-1.57,1.38H47.34V4.43h6.88a1.57,1.57,0,0,1,1.57,1.4ZM53.12,0H42.47v20.1h4.89V12h5.39a2.8,2.8,0,0,1,2.74,2.85v5.27h4.79V13.62a4.21,4.21,0,0,0-2.9-3.89,4.5,4.5,0,0,0,3-4.44C60.34.94,56.6,0,53.12,0M18.76,15.27c-.07,0-6.69.13-9-.09a5.16,5.16,0,0,1-5-5.31,5.14,5.14,0,0,1,4.82-5.2c1.39-.19,9-.1,9.09-.1h.16L18.9,0h-.16L10.11,0A12.73,12.73,0,0,0,5.93.84,10.25,10.25,0,0,0,2,4a10,10,0,0,0-2,6,12.15,12.15,0,0,0,.16,2A9.8,9.8,0,0,0,5.65,19a14.72,14.72,0,0,0,5.46,1.11l1.63,0h6.17V15.27Z"
        />
        </svg>
    </div>
    </>
  );
};

export default Footer;
